import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { robotIcon } from './chatIcons';
import ContinueButtonBar from './components/ContinueButtonBar';
import './FillingFormsIntroChatFlow.css';

export interface FillingFormsIntroChatFlowProps {
  onBack: () => void;
  onContinue: () => void;
}

const BUBBLE_DELAY_MS = 650;

function AssistantRow({
  children,
  animateIn = false,
}: {
  children: React.ReactNode;
  animateIn?: boolean;
}) {
  return (
    <div className={`fill-forms-chat__row ${animateIn ? 'fill-forms-chat__row--enter' : ''}`}>
      <div className="fill-forms-chat__avatar-wrap" aria-hidden>
        <img src={robotIcon} alt="" className="fill-forms-chat__avatar" />
      </div>
      <div className="fill-forms-chat__bubble-wrap">
        <div className="fill-forms-chat__bubble">{children}</div>
      </div>
    </div>
  );
}

const FillingFormsIntroChatFlow: React.FC<FillingFormsIntroChatFlowProps> = ({ onBack, onContinue }) => {
  const { t } = useLanguage();
  const [revealedCount, setRevealedCount] = useState(0);
  const threadEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setRevealedCount(0);
    const timers: number[] = [];
    timers.push(window.setTimeout(() => setRevealedCount(1), 150));
    timers.push(window.setTimeout(() => setRevealedCount(2), 150 + BUBBLE_DELAY_MS));
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, []);

  useEffect(() => {
    threadEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [revealedCount]);

  return (
    <div className="fill-forms-chat">
      <div className="fill-forms-chat__card">
        <header className="fill-forms-chat__top">
          <button type="button" className="fill-forms-chat__cancel-pill" onClick={onBack}>
            <span className="fill-forms-chat__cancel-x" aria-hidden>
              ×
            </span>
            {t('submitDocuments.chat.cancelProcedure')}
          </button>
        </header>

        <div className="fill-forms-chat__thread-wrap">
          <div className="fill-forms-chat__thread" role="log" aria-live="polite">
            {revealedCount >= 1 && (
              <AssistantRow animateIn>{t('submitDocuments.fillInIntro.p1')}</AssistantRow>
            )}
            {revealedCount >= 2 && (
              <AssistantRow animateIn>{t('submitDocuments.fillInIntro.p2')}</AssistantRow>
            )}
            <div ref={threadEndRef} />
          </div>
        </div>

        {revealedCount >= 2 && (
          <footer className="fill-forms-chat__footer fill-forms-chat__footer--enter">
            <ContinueButtonBar
              onContinue={onContinue}
              label={t('submitDocuments.fillInIntro.continue')}
            />
          </footer>
        )}
      </div>
    </div>
  );
};

export default FillingFormsIntroChatFlow;

